import * as types from '../../store/constants';
import { useCallback, useMemo } from 'react';
import { usePaginationAndSortParams } from '../hooks/usePaginationAndSortParams';
import Base64 from '../utils/base64';
import { useSearchParams } from 'react-router-dom';
import { GroupingState } from '../../../models/GroupItem';

const GROUP_BY_SEARCH_PARAM = 'groupBy';

export function useGroupBySearchParam() {
    const [searchParams, setSearchParams] = useSearchParams();
    const { resetPageParam } = usePaginationAndSortParams();

    const groupByQueryParam = searchParams.get(GROUP_BY_SEARCH_PARAM);

    const parsedGrouping: GroupingState = useMemo(
        () => (!groupByQueryParam ? { key: types.GROUPBY_PRODUCTS } : JSON.parse(Base64.decode(groupByQueryParam))),
        [groupByQueryParam]
    );

    const replaceURLGroupByEntry = useCallback(
        (groupBy: { readonly key: string; readonly label?: string }) => {
            setSearchParams(
                current => {
                    if (groupBy.key === types.GROUPBY_PRODUCTS) {
                        current.delete(GROUP_BY_SEARCH_PARAM);
                    } else {
                        // FIXME: it should be sufficient to use the `key` as query param value instead of thw whole object
                        current.set(GROUP_BY_SEARCH_PARAM, Base64.encode(JSON.stringify(groupBy)));
                    }
                    return resetPageParam(current);
                },
                { replace: true }
            );
        },
        [resetPageParam, setSearchParams]
    );

    const deleteURLGroupByEntry = useCallback(() => {
        setSearchParams(
            current => {
                current.delete(GROUP_BY_SEARCH_PARAM);
                return resetPageParam(current);
            },
            { replace: true }
        );
    }, [resetPageParam, setSearchParams]);

    return { parsedGrouping, replaceURLGroupByEntry, deleteURLGroupByEntry };
}
